import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const WarrantyPageLink = () => (
  <p className="mt-1">
    Please visit our{' '}
    <Link to="/warranty/" className="text-brand cursor-pointer">
      warranty page
    </Link>{' '}
    for more information.
  </p>
);

const WarrantyMessage = ({ yearsSinceOrderDelivered }) => {
  const message = useMemo(() => {
    if (yearsSinceOrderDelivered > 1 && yearsSinceOrderDelivered < 4) {
      return (
        <>
          Please note that part of your warranty has expired: Our One-Year
          Limited Warranty coverage applies to any manufacturer&apos;s defects
          or shipping damage to our fabric, leather, cushioning, seams, tufting,
          mattresses, wood stains or finishes, moving or mechanical mechanisms
          found in sleepers, storage items, and recliners and electrical parts
          and motors (including battery packs).
        </>
      );
    }
    if (yearsSinceOrderDelivered > 3 && yearsSinceOrderDelivered < 11) {
      return (
        <>
          Please note that part of your warranty has expired: Our One-Year
          Limited Warranty coverage applies to any manufacturer&apos;s defects
          or shipping damage to our fabric, leather, cushioning, seams, tufting,
          mattresses, wood stains or finishes, moving or mechanical mechanisms
          found in sleepers, storage items, and recliners and electrical parts
          and motors (including battery packs).
          <p>
            Our Three-Year Limited Warranty coverage applies to the springs and
            bed slats of your product.
          </p>
        </>
      );
    }
    if (yearsSinceOrderDelivered > 10) {
      return (
        <>
          Please note that your warranty has expired. Our Limited Lifetime
          Warranty coverage applies from the day you receive your product to 10
          years after the initial order delivery date to all of the foundational
          elements of your furniture: wood frames, joints, bases, legs, and
          hardware, which are integral to the life of your product.
        </>
      );
    }
    return '';
  }, [yearsSinceOrderDelivered]);
  if (message) {
    return (
      <div className="rounded mt-2 text-base">
        <p className="text-justify">{message}</p>
        <WarrantyPageLink />
      </div>
    );
  }
  return null;
};

WarrantyMessage.propTypes = {
  yearsSinceOrderDelivered: PropTypes.number,
};
export default WarrantyMessage;
